import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { useQuery } from "@tanstack/react-query";
import type { UnifiedElement, UnifiedResponse } from "@/types/diagram";
import { transformToUnifiedResponse } from "@/lib/utils";
import { apiFetch } from "@/lib/api-client";

export default function useGetSearchedShapesService(
  query: string,
  enabled?: boolean
) {
  const { getAuthHeaders } = useAuthHeaders();

  const getSearchedShapes = async (): Promise<
    | {
        data: UnifiedElement[];
        total: number;
      }
    | undefined
  > => {
    const url = `${config.isometricApiUrl}/shapes/search/${query}`;

    try {
      const response = await apiFetch(url, {
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const shapesResp: { data: UnifiedResponse[]; total: number } =
        await response.json();
      const unifiedData = transformToUnifiedResponse(shapesResp?.data ?? []);
      return { data: unifiedData, total: shapesResp.total };
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["searched-shapes", query],
    queryFn: getSearchedShapes,
    enabled: !!enabled && !!query,
  });
}
